import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=4904444a&scoped=true&"
import script from "./IconsList.vue?vue&type=script&lang=js&"
export * from "./IconsList.vue?vue&type=script&lang=js&"
import style0 from "./IconsList.vue?vue&type=style&index=0&id=4904444a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904444a",
  null
  
)

export default component.exports